import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import axios from 'axios';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import "react-big-calendar/lib/css/react-big-calendar.css";
import StaffSchedulePopup from './StaffSchedulePopup';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'; 
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';

import Select from '@mui/material/Select';
moment.locale("en-GB");

const localizer1 = momentLocalizer(moment);

export default class StaffSchedule extends Component {

   constructor(props) {
      super(props);
	   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
      this.state = {scheduledata:[],redirect:false,slotData:[],type:'1',pagename:'',stsid:'',weekday:'Monday',weekval:'0',strmonthyaer:Date.now(),strmonthyaer1:strdob.getFullYear() + '-' + month ,slotname:'',lcid:'',estid:'',eclstyp:'',eorid:'',orname:'',Branchdata:[],branchid:'',eorcuid:0,
	 weeks: [
        {
          val: "0",
          name: "Monday",
         }, {
          val: "1",
          name: "Tuesday",
         }, {
          val: "2",
          name: "Wednesday",
         }, {
          val: "3",
          name: "Thursday",
         }, {
          val: "4",
          name: "Friday",
         }, {
          val: "5",
          name: "Saturday",
         }, {
          val: "6",
          name: "Sunday",
         }
      ]
	  }
	    this.updateDoneweekload = this.updateDoneweekload;
	  
   }
   
	updateDoneweekload = (text) => {  this.onloadslot(); }
   handleSelectweek(val,day){
	   this.setState({weekval: val ,weekday: day},()=>{this.onloadslot();})
   }
   handleSelect=(date)=>{
	console.log(date);
 var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date1=date.getFullYear()+"-"+month+"-"+date1
	 this.setState({ stsid: "0" ,celldate:date1,edate:date});  
 /*   const title = window.prompt("New Event name");

     const updatedArray = [...this.state.eventsData];
	 updatedArray.title=title;
	 	 updatedArray.start=start;
		 updatedArray.end=end;
	 this.setState({eventsData:updatedArray});*/
	setTimeout(() => this.refs.StaffSchedulePopup.handleClickOpen(),500);
 }
  handleNotification=(start,stsid,classattended,classtype,smid,cuid,orname,or_cu_id)=>{
	if(classattended==="0")
	{
	
	   this.setState({celldate:start, stsid: stsid,eclstyp:classtype,slotname:smid,eorid:cuid,orname:orname,eorcuid:or_cu_id,
	   },()=>{
	
		  this.refs.StaffSchedulePopup.handleClickOpen()
		   });  
	}
	else{
		
		alert("You can not alter the schedule")
		return false;
	}
	  
  }
  updateDonenewParent = (text) => {  this.StaffScheduleAPIcall(); }
      componentWillMount()
	  {
		  
		 	document.title = "AthaYog Living - Schedule Staff";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
		  
		   this.onloadBranch();
	  }
  
  
StaffScheduleAPIcall()
{
axios.get(Serverurl+'ajaxstaffschedule.php?action=list&sm_bm_id='+this.state.branchid)
       .then(resp => { 		
			if(resp.data.length>0){
				
				let schedulearr=resp.data;
				let transformed = [];
				/*var obj=schedulearr.forEach(eachrep => {
					
					
					eachrep.start=new Date(eachrep.start+" "+eachrep.time),
					eachrep.end=new Date(eachrep.end+" "+eachrep.totime);
					
				});*/
				schedulearr.sort((a, b) => a.id > b.id ? 1 : -1).forEach(eachrep => {
				
					eachrep.start=new Date(eachrep.start+" "+eachrep.time);
					eachrep.end=new Date(eachrep.end+" "+eachrep.totime);

				});
				
				this.setState({scheduledata:resp.data});
			}
	   });
}
myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val},()=>{
	  
	  if(nam=="branchid" && this.state.type==="2")
	  {
		  this.onloadslot(); 
	  }
	  else if(nam=="branchid" && this.state.type==="1")
	  {
		  this.StaffScheduleAPIcall(); 
	  }
  })
		}
 onloadslot(){
		
		axios.post(Serverurl+'ajaxstaffbookings.php?day='+this.state.weekval+'&monthyear='+this.state.strmonthyaer1+'&sm_bm_id='+this.state.branchid)
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						slotData:resp.data	
							})

	
			}else{
				this.setState({slotData:[]});
			}
 
    });
		
	} 
  

customDayPropGetter = (date) => {

  let data = this.state.scheduledata
 
   var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
   
  date=date.getFullYear()+"-"+month+"-"+date1;
  
   var obj = data.find((item, index) => {
	  
	   
	   
	   
	     if ((item.date === date && item.title !== "")  )
		 {
			 
			   return data[index]
		 }
   });

    /* console.log(obj)
	if(obj !== undefined && obj.date === date &&  obj.title !== "")
	{
		if(obj.cs_classattended==="1")
		{
			  return { style: { backgroundColor: "#f44336", Color:'#fff' } }
		}
		else if(obj.id!=="0"){
	 
        return { style: { backgroundColor: "#728359", Color:'#fff' } }
		}
		else if(obj.cs_classattended==="0"){
	 
        return { style: { backgroundColor: "#2588f5", Color:'#fff' } }
		}
		 
		
	}*/
     
        return { style: { backgroundColor: "#fff", Color:'#fff' } }
   
	
}
onloadBranch()
{
	axios.post(Serverurl+'ajaxbranch.php?action=getall&sorting=bm_id')
  .then(resp => {  
		
  if(resp.data.length>0){
	  this.setState({Branchdata:resp.data,},()=>{
								let strbrid="";

								
									strbrid=resp.data[0]["bm_id"];
								
								 let BranchFromApi = this.state.Branchdata.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
	
        this.setState({branchid:strbrid,
          Branchdata: BranchFromApi
        },()=>{	
		
		if(this.state.type==="2")
		{
		this.onloadslot();
		}if(this.state.type==="1")
		{
	this.StaffScheduleAPIcall();
		}		});
								
							})


					
  }else{
	  this.setState({Branchdata:[]});
  }
   
  });
	
}
 eventStyleGetter=(event,start, end,isSelected)=>{


    var backgroundColor = '#' + event.color;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: '#fff',
        border: '0px',
        display: 'block',
		textalign:'Center',
    };
    return {
        style: style,
		start:  new Date(Date.parse(start)),
		end:  new Date(Date.parse(end)),
    };
}

  
onChangeday = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({type: event.target.value},()=>{
			 
			 
				 this.onloadBranch();
				 
			 
			 
		 });
	}	     
 
  handlemonthChange = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	
     this.setState({ strmonthyaer:date,
strmonthyaer1:date.getFullYear() + '-' + month 
	 },()=>{this.onloadslot();})
	
	
  }

	handleWeeklySchedule (slot,lcid){
this.setState({ slotname: slot,lcid:lcid },()=>{
	
		  this.refs.Weekschedulebox.handleClickOpen();
		   }); 


	}
handleWeeklyEditSchedule (slot,lcid,stid,classtyp,orid){

this.setState({ slotname: slot,lcid:lcid,estid:stid,eclstyp:classtyp,eorid:orid },()=>{
	
		  this.refs.Weekschedulebox.handleClickOpen();
		   }); 


	}
	
render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }

  return (
<React.Fragment> 

 <div className="mainheading"><h1> Schedule Yoga Trainer</h1></div>

<StaffSchedulePopup ref="StaffSchedulePopup" brid={this.state.branchid} id={this.state.stsid} eorcuid={this.state.eorcuid} celldate={this.state.celldate} edate={this.state.edate} slotname={this.state.slotname}
eorid={this.state.eorid} orname={this.state.orname}  eclstyp={this.state.eclstyp}  updateDonenew={this.updateDonenewParent}/>

<div className="clear"></div>


<FormControl className="preference">
  
      <RadioGroup  value={this.state.type}
        defaultValue={this.state.type}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"   onChange={this.onChangeday}
      >
        <FormControlLabel value="1" control={<Radio />} label="Day Wise" />
        <FormControlLabel value="2" control={<Radio />} label="Monthly Wise" />
        
      </RadioGroup>
    </FormControl>
	{this.state.type==="1" && (
	
<div className="contntpad">
{localStorage.getItem("AYLrole")==="1" && (
<p>
<FormControl  className="stadrp">			   
			<Select
			className="txtbox"
			native
			value={this.state.branchid}
			onChange={this.myChangeHandler}
			name='branchid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p> )}
  <Calendar
        views={["day",  "month"]}
        selectable
        localizer={localizer1}
        defaultDate={new Date()}
        defaultView="month"
		dayPropGetter={this.customDayPropGetter}
        events={this.state.scheduledata}
        style={{ height: "140vh" }}
        onSelectEvent={(event) => this.handleNotification(event.date,event.id,event.cs_classattended,event.or_classtype,event.cs_sm_id,event.cs_or_id,event.or_name,event.or_cu_id)}
		 eventPropGetter={(this.eventStyleGetter)}
        onSelectSlot={(event)=>this.handleSelect(event.date)}
      /> 
</div>
	)}
	{this.state.type==="2" && (
	
	<React.Fragment>
	<div className="searchmaster">


  
  <ul>
 {localStorage.getItem("AYLrole")==="1" && (
  <li>
<p>Select Branch</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			className="txtbox"
			native
			value={this.state.branchid}
			onChange={this.myChangeHandler}
			name='branchid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
  )}
	<li><p>Date</p><p>
 <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker  views={['year', 'month']}
value= {dayjs(this.state.strmonthyaer) }
className="txtbox" 
 inputProps={{tabIndex: "1"}}
    onChange={this.handlemonthChange} format="MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
		
		</p></li><li></li>
		</ul>
		</div>
	<ul className="weekselec">
	{this.state.weeks.map((item,index) => {  
			
           return (
	<React.Fragment>
	
	{this.state.weekday===item.name && (
	<li className="weeksele" onClick={()=>{this.handleSelectweek(item.val,item.name)}}>{item.name}</li>
	)}
	{this.state.weekday!==item.name && (
	<li  onClick={()=>{this.handleSelectweek(item.val,item.name)}}>{item.name}</li>
	)}
	</React.Fragment>
	)
	})}
	</ul>
	<h2 className="aligncentr">{this.state.weekday}</h2>
	<Weekschedulebox ref="Weekschedulebox" weekval={this.state.weekval} weekday={this.state.weekday} monthyear={this.state.strmonthyaer1} slotname={this.state.slotname} lcid={this.state.lcid} bmid={this.state.branchid} estid={this.state.estid} eorid={this.state.eorid} eclstyp={this.state.eclstyp} updateDoneweek={this.updateDoneweekload}/>
	
	<Paper >


  <TableContainer >  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
<TableCell>                                     
         
				 </TableCell>
				 <TableCell>                                     
        Personal Training Online
				 </TableCell>
          <TableCell>                                     
         Studio Class   
				 </TableCell>	
 <TableCell> Personal Training Room 03                                    
         
				 </TableCell> <TableCell>                                     
          Personal Training at Home  
				 </TableCell><TableCell>                                     
         Personal Training Room 01    
				 </TableCell><TableCell>                                     
         Personal Training Room 02    
				 </TableCell>
				 
                      </TableRow></TableHead>
					  
					  
                      <TableBody>
                     {this.state.slotData.map((item,index) => { 
			 
           return (
 <React.Fragment>
 <TableRow key={index} >

 <TableCell>
 {item.sm_slotname}
 </TableCell>
 
 
 <TableCell>
  
   {item.customer6.length>0 &&(
  <ul className="submembers">
   {item.customer6.map((col1,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,6,col1.sts_st_id,col1.sts_classtype,col1.or_id)}}>{col1.scnames} </li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
  
  {item.customer6.length===1 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,6)}}/>
   
 </React.Fragment>	
  )}
  {item.customer6.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,6)}}/>
    <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,6)}}/>
 </React.Fragment>	
  )}
 </TableCell>
 

  <TableCell>
  {item.customer5.length>0 &&(
  <ul className="submembers">
   {item.customer5.map((col1,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,5,col1.sts_st_id,col1.sts_classtype,col1.or_id)}}>{col1.scnames} </li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
  {item.customer5.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,5)}}/>
 </React.Fragment>	
  )}
 </TableCell>
  <TableCell> 
  
   {item.customer4.length>0 &&(
  <ul className="submembers">
   {item.customer4.map((col2,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,4,col2.sts_st_id,col2.sts_classtype,col2.or_id)}}>{col2.scnames} </li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
 {item.customer4.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,4)}}/>
   </React.Fragment>	
  )}
  
 </TableCell>
  <TableCell>
  
   {item.customer3.length>0 &&(
  <ul className="submembers">
   {item.customer3.map((col3,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,3,col3.sts_st_id,col3.sts_classtype,col3.or_id)}}>{col3.scnames} </li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
  
  {item.customer3.length===1 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,3)}}/>
   
 </React.Fragment>	
  )}
  {item.customer3.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,3)}}/>
    <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,3)}}/>
 </React.Fragment>	
  )}
 </TableCell>
  <TableCell>
  
   {item.customer2.length>0 &&(
  <ul className="submembers" >
   {item.customer2.map((col4,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,2,col4.sts_st_id,col4.sts_classtype,col4.or_id)}}>{col4.scnames} </li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
  {item.customer2.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,2)}}/>
   </React.Fragment>	
  )}
 </TableCell>
 <TableCell>
 
 {item.customer1.length>0 &&(
  <ul className="submembers" >
   {item.customer1.map((col5,row) => { 
  
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,1,col5.sts_st_id,col5.sts_classtype,col5.or_id)}}>{col5.scnames} </li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )} {item.customer1.length===0 && ( <React.Fragment>
 <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,1)}}/>
    </React.Fragment>	
  )}
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					
                      </TableBody>


</Table>
  </TableContainer> 
  
  </Paper>
	</React.Fragment>
	)}
  </React.Fragment> 
  
  
  )


  }
	  
	  
 
	  
	  
	  
	   }
	
export  class  Weekschedulebox extends Component {
		
	 constructor(props) {
	   super(props)	
		
		 this.state = {open:false,custdata:[],staffarray:[],staff:'',slotid:'',custid:'0',classtype:'',classname:'',locationname:'',cuid:0,cusorid:'',btndisable:false,btntext:'Save'}
		 
	 }
	 
	handleClickOpen = (e) => {
		var strcls="",strlocnam="";
		this.onloadStaffbind();
		
		
		
		if(this.props.lcid===3)
		{
			strcls="1";
			strlocnam="Personal Training at Home";
			
		}
	else if(this.props.lcid===2)
		{
			strcls="2";
			strlocnam="Personal Training Room 02";
		}
		else if(this.props.lcid===1)
		{
			strcls="2";
			strlocnam="Personal Training Room 01";
		}
		else if(this.props.lcid===6)
		{
			strcls="6";
				strlocnam="Personal Training Online";
		}
		else if(this.props.lcid===4)
		{
			
				strlocnam="Personal Training Room 03 ";
		}
		else if(this.props.lcid===5)
		{
			
				strlocnam="Studio Class ";
		}
		if(this.props.eclstyp!=="")
		{
			strcls=this.props.eclstyp
		}
	
this.setState({open:true,classtype:strcls,locationname:strlocnam,staff:this.props.estid,errormessage:'',erropen:false,slotid:'1'},()=>{
	
	if(strcls!="")
	{
		 this.onloadslot();
	}else{
		 this.setState({alertype:"error",errormessage:"Slot doesn't exist for this class type",erropen:true});
	}
	
});

	}
onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({classtype: event.target.value},()=>{ this.onloadslot();
		
		
		 });
	}
		myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val},()=>{
	  if(nam==="custid")
	  {let strarr=val.split('~');
		 this.setState({cusorid: strarr[0],cuid:strarr[1]} );
	  }
	 
  })
		}
	onloadslot(){
		
		axios.post(Serverurl+'ajaxslotmanagement.php?action=getbyname&sm_slotname='+this.props.slotname+'&sm_slottype='+this.state.classtype+'&sm_bm_id='+this.props.bmid)
  .then(resp => {  
		
  if(resp.data.length>0){
	   this.setState({slotid:resp.data[0]["sm_id"],erropen:false,errormessage:''},()=>{this.onloadCustomer()});
	  
  }else{
	 
	   this.setState({alertype:"error",errormessage:"Slot doesn't exist for this class type",erropen:true,slotid:''});
  }
  })
  
	}
onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3')
	
    
      .then((response) => {    
     
      this.setState({  staffarray: response.data,  },()=>{
		  
		  let roleFromApi = this.state.staffarray.map(st => {
                            
          return {value: st.st_id, display:st.st_name}
        });
      
		
        this.setState({
          staffarray: [{value: '', display: 'All'}].concat(roleFromApi)
        });
		  
		  
	  });
      })   
    
     


}

	onloadCustomer(){
		
		axios.post(Serverurl+'ajaxcustomerschedule.php?action=getweekcust&cs_sm_id='+this.state.slotid+'&cs_date='+this.props.monthyear+'&cs_id='+this.props.weekval+'&or_booktype='+this.state.classtype)
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({ ispanel: true,
						custdata:resp.data	
							},()=>{
								
								
								 let custApi = this.state.custdata.map(row => {
                          
          return {value:row.or_id+"~"+row.or_cu_id,display:row.or_name}
        });
      
		
        this.setState({
          custdata: [{value: '0', display:'Select Customers'}].concat(custApi)
        },()=>{
			
			if(this.props.eorid!=="")
			{
				 this.setState({cusorid:this.props.eorid});
				
			}
			
		});
								
							})

	
			}else{
				this.setState({custdata:[],ispanel: false,});
			}
 
    });
		
	}	
	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 
  handleClickClose= (e) => { this.setState({open:!this.state.open,}); } 
handleSave=(event)=>{
	let monthyear = this.props.monthyear;
let weekday = this.props.weekday;
let staff = this.state.staff;	
let classtype = this.state.classtype;
let lc_id = this.props.lcid;
let slotid = this.state.slotid;	
let cusorid = this.state.cusorid;
let cuid = this.state.cuid;

if(classtype==="")
{
	
	this.setState({errormessage:"Please Select  Preference",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(staff==="")
{
	
	this.setState({errormessage:"Please Select  Staff",erropen:true});
		 window.scrollTo({       top: 0
      })
		 return false;
		
}
if(this.state.classtype==="1" || this.state.classtype==="2"){
if(staff==="")
{
	
	this.setState({errormessage:"Please Select  Staff",erropen:true});
		 window.scrollTo({       top: 0
      })
		 return false;
		
}
}
this.setState({errormessage:"",erropen:false,btndisable:true,btntext:'Processing...'});

var formData = new FormData();
formData.append('action','WeeklySchedulebulk') 
formData.append('monthyear',monthyear)
formData.append('weekday',weekday)	
formData.append('cs_st_id',staff)	
formData.append('classtype',classtype)	
formData.append('lc_id',lc_id)	
formData.append('cs_sm_id',slotid)	
formData.append('cs_or_id',cusorid)

formData.append('cuid',cuid)
formData.append('userid',localStorage.getItem("AYLuserid"))
axios.post(Serverurl+"ajaxcustomerschedule.php", formData, {
        }).then(res => {
				if(res.data !==0)
			{ 
			this.setState({btndisable:false,btntext:'Save',errormessage:"Staff has been Successfully Scheduled",erropen:false,classtype:'',staff:'',slotid:'',open:false},()=>{this.props.updateDoneweek();});
			}else{
				this.setState({btndisable:false,btntext:'Save',errormessage:"Please try with another slot",erropen:true,});
			}
		})
}

render (){

return(
<React.Fragment>
 <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title" className="dwnloadspanel">
      <DialogTitle id="form-dialog-title"> 
	   {this.props.weekday}, {this.props.slotname} Schedule at {this.state.locationname}
	  </DialogTitle>
      <DialogContent>
	
	  <p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alertype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  {this.state.slotid!='' && (
	  <div className="scheduelpop">
	  <ul>
	   {(this.props.lcid!==3 && this.props.lcid!==2 && this.props.lcid!==6  && this.props.lcid!==1) && (<React.Fragment><li>
<p><span className="validation">*</span>Select Your Preference</p>

<FormControl className="preference">
  
      <RadioGroup  value={this.state.classtype}
        defaultValue={this.state.classtype}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"   onChange={this.onChangeClass}
      >
	  
			
			
			
        <FormControlLabel value="2" control={<Radio />} label="Personal Training in Studio" />
        <FormControlLabel value="3" control={<Radio />} label="Group" />
        <FormControlLabel value="4" control={<Radio />} label="Prenatal" />
	
      </RadioGroup>
    </FormControl>

</li></React.Fragment>)}
{this.state.classtype!='' &&(
  <li><p><span className="validation">*</span> Select Staff</p>
<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.staff }}
          onChange={this.myChangeHandler}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
</li>
)}


{(this.state.classtype==='1' || this.state.classtype==='2' || this.state.classtype==='6') &&(<li>
<p><span className="validation">*</span> Select Customers</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native
			value={this.state.custid}
			onChange={this.myChangeHandler}
			name='custid'
			
			fullwidth
			
			
			>
		
		
			{this.state.custdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
)}

</ul>

	 
       <div className="actionbtn">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickClose}  className="frmthirdbtn">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleSave} disable={this.state.btndisable}  className="frmSecondarybtn">
			{this.state.btntext}
        </Button>
		</div></div>
<div className="clear"></div>	</div>
	  )}
	  {this.state.slotid==='' && (
	  <div className="cancelbtn">	  
        <Button onClick={this.handleClickClose}  className="frmthirdbtn">
          Cancel
        </Button></div> 
	  
	  )}
	 	
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
} 

  





















  
 